'use client'

import { useCallback } from 'react'
import { useParams } from 'next/navigation'
// import Link from 'next/link'
import {Link} from '@/navigation'
import { useTagStore } from '@/lib/useTagStore'
import { type Locale } from '@/navigation'
import { Badge } from '@/components/ui/badge'

interface Props {
  text: string
}

const Tag = ({ text }: Props) => {
  //const locale = useParams()?.locale as Locale
  const { setSelectedTag } = useTagStore()

  const handleClick = useCallback(() => {
    setSelectedTag(text)
  }, [text, setSelectedTag])

  return (
    // <Link href={`/${locale}/blog`}>
    <Link href={`/blog/all`} onClick={handleClick}>
      <Badge
        variant="secondary"
        className="mr-2 cursor-pointer hover:bg-secondary/80"
      >
        {text.split(' ').join('-')}
      </Badge>
    </Link>
  )
}

export default Tag